module.exports = {
          srcSet: __webpack_public_path__ + "img/eab2c58-1580.png"+" 1580w",
          images:[ {path: __webpack_public_path__ + "img/eab2c58-1580.png",width: 1580,height: 378}],
          src: __webpack_public_path__ + "img/eab2c58-1580.png",
          toString:function(){return __webpack_public_path__ + "img/eab2c58-1580.png"},
          
          width: 1580,
          height: 378
        }